import { Component, inject } from '@angular/core';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { TableLazyLoadEvent, TableModule, TableRowSelectEvent } from 'primeng/table';
import { PensionsudbydereService } from '../pensionsudbydere.service';
import { KeepScrollPositionDirective } from '@shared/directives/keep-scroll-position.directive';

@Component({
  selector: 'app-pu-result',
  imports: [TableRowDirective, TableModule, KeepScrollPositionDirective],
  templateUrl: './pu-result.component.html',
  styleUrl: './pu-result.component.css',
})
export class PuResultComponent {
  puService = inject(PensionsudbydereService);
  data = this.puService.datasource.data;

  onRowSelect(e: TableRowSelectEvent) {
    this.puService.selectPuResultRow(e.data);
  }

  onLazyLoad(event: TableLazyLoadEvent) {
    this.puService.datasource.loadData(
      event.sortField,
      event.sortOrder === -1,
      event.first
    );
  }
}
